<template>
  <div>
    <px-view-header title="Fornecedor" title-class="font-weight-bold" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" link to="/fornecedores">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && fornecedor">
      <px-fornecedor-detalhes-dados-basicos :fornecedor="fornecedor"
                                            :score="score"
                                            :loading-score="loadingScore"
                                            @update="onUpdate"/>
      <px-fornecedor-detalhes-tabs class="mt-3"
                                   :fornecedor="fornecedor"
                                   @update="onUpdate"/>
    </div>
  </div>
</template>

<script>
import FornecedorService from '@/api/fornecedor-service';
import FornecedorDetalhesDadosBasicos from './FornecedorDetalhesDadosBasicos.vue';
import FornecedorDetalhesTabs from './FornecedorDetalhesTabs.vue';
import GestaoFornecedorService from '../../gestao-fornecedor-service';

export default {
  data() {
    return {
      id: this.$route.params.id,
      loading: false,
      loadingScore: false,
      fornecedor: null,
      score: null,
      breadcrumbs: [
        { text: 'Gestão de fornecedores' },
        { text: 'Fornecedores', to: '/fornecedores' },
        { text: 'Detalhes' },
      ],
    };
  },
  methods: {
    getFornecedor() {
      this.loading = true;
      GestaoFornecedorService.get(this.id)
        .then(({ data }) => {
          this.fornecedor = data;
          this.getScore();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getScore() {
      this.loadingScore = true;
      FornecedorService.getFornecedorScore(this.fornecedor.fornecedor.id)
        .then(({ data }) => {
          this.score = data;
        })
        .finally(() => {
          this.loadingScore = false;
        });
    },
    onUpdate() {
      this.getFornecedor();
    },
  },
  created() {
    this.getFornecedor();
  },
  components: {
    pxFornecedorDetalhesDadosBasicos: FornecedorDetalhesDadosBasicos,
    pxFornecedorDetalhesTabs: FornecedorDetalhesTabs,
  },
};
</script>
